import React from 'react';
import Pulse from './pulse';

const HOTSPOT_CUSTOM = [
  {
    id: '675298b797d14bbd943b8b2a',
    img: '/assets/icons/arrows/arrow_right.png',
    name: 'CO_DIEN_17',
  },
  {
    id: '675298b797d14bbd943b8b2b',
    img: '/assets/icons/arrows/arrow_left.png',
    name: 'SERVER_2_20',
  },
];

const IconFlickedArrow = ({ id, imgUrl = '', title = '' }) => {
  const isArrow = HOTSPOT_CUSTOM.some((item) => item.id === id);

  const _renderIcon = () => {
    if (isArrow) {
      const arrow = HOTSPOT_CUSTOM.find((item) => item.id === id);
      return <img alt="" className="icon-img" src={arrow.img} />;
    }

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 384 512"
        style={{ width: '16px', height: '16px' }}
        fill="#fff"
      >
        <path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
      </svg>
    );
  };

  return (
    <div className="icon-container">
      {!isArrow && <Pulse />}
      <div className={`icon_custom_location ${isArrow ? 'bg-none' : ''}`}>
        {_renderIcon()}
        <p className="icon-title">{title}</p>

        <div className="icon-content-preview">
          <img src={imgUrl} alt="flicked-arrow" />
          <p>{title}</p>
        </div>
      </div>
    </div>
  );
};

export default IconFlickedArrow;
